import { ConvertToAUDateTimeUTC } from "../../../shared/utils/datetime.helper";

export function getPostponeDate(numberOfDays: number): Date {
  const postponedDate = new Date();

  postponedDate.setDate(postponedDate.getDate() + numberOfDays);
  postponedDate.setHours(0, 0, 0, 0);

  return ConvertToAUDateTimeUTC(postponedDate);
}
